import {
  CREATEVACATION,
  GETVACATION,
  DELETEVACATION,
  UPDATEVACATION,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETVACATION:
      return {
        ...state,
        vacationList: action.payload.data,
      };
    case UPDATEVACATION:
      return {
        ...state,
        vacationUpdateStatus: action.payload.success,
      };

    case DELETEVACATION:
      return {
        ...state,
        vacationDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
